// export var langDict = ["中文", "English", "日本語", "Deutsch", "русский язык", "한국어"];
// export var langAbbr = ["zh", "en", "ja", "de", "ru", "kr"];
// export var langCourses = [6, 6, 3, 3, 3, 3];
export var langDict = ["中文", "English"];
export var langAbbr = ["zh", "en"];
export var langCourses = [6, 6];
